module.exports = __webpack_public_path__ + "img/tier3-more-info.35aada0.svg";